import { NodeSource } from "@omegagrid/tree";

export type UsageRange = '7d' | '30d' | '6m' | '12m';

export const USAGE_RANGES: NodeSource[] = [
	{ k: '7d', v: 'Last {v} days' },
	{ k: '30d', v: 'Last {v} days' },
	{ k: '6m', v: 'Last {v} months' },
	{ k: '12m', v: 'Last {v} months' },
];

export interface ChatDefault {
	model: string;
	includeData?: boolean;
	/** statement-defining tools; only ever true for users with the definition right */
	includeDefinition?: boolean;
	/** reading the other companies of the accounting group; only ever true when canReadGroup is */
	includeGroup?: boolean;
	enableThinking?: boolean;
	/** whether the Group toggle is offered at all: an SA, or another company of the group the user may use AI in */
	canReadGroup?: boolean;
}

/**
 * The chat's state persisted in the `ai.chat.settings` setting (user-accounting scope): the toggles
 * and the last selected model. Served back as the default of a new chat (GET ai/default). The common
 * tools are always on (no Tools toggle).
 */
export interface ChatSettings {
	includeData: boolean;
	includeDefinition: boolean;
	includeGroup: boolean;
	enableThinking: boolean;
	model?: string;
}

export interface ChatAttachmentRef {
	idz?: number;
	media_type: string;
	file_name?: string;
	data?: string;
}
